import type { Tariff } from './types'
import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/shared/api'

export function fetchTariffsRequest() {
  return apiClient.get<Tariff[]>('/tariffs/')
}

export function useTariffsQuery() {
  return useQuery({
    queryKey: ['tariffs'],
    queryFn: fetchTariffsRequest,
    staleTime: 5 * 60 * 1000,
  })
}
